import React, { useState, useRef, useCallback, useMemo, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Table from "../../../_common/Table";
import EditCcoModalV2 from "./EditCcoModalV2";
import ProjAdminCcoDetails from "./CcoDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import ccoActions from "../../../../_actions/ccoActions";
import locationActions from "../../../../_actions/locationActions";
import "../styles/projAdmin.css";

export default function ProjAdminCcoListV2(props) {
  const { projectId, permissions } = props;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(ccoActions.getAll(projectId));
    dispatch(locationActions.getAll(projectId));
  }, []);

  const projCcoList = useSelector((state) => state.ccos.projCcoLists[projectId] || null);
  const projLocationList = useSelector(
    (state) => state.locations.projLocationLists[projectId] || null
  );

  const [modalState_edit, setModalState_edit] = useState({
    showModal: false,
    ccoId: null,
  });
  const toggleModal_edit = () =>
    setModalState_edit({ ...modalState_edit, showModal: !modalState_edit.showModal });

  const [descFilter, setDescFilter] = useState("");
  const [sortColumn, setSortColumn] = useState({ path: "ccoNo", order: "asc" });
  const [selectedCcoId, setSelectedCcoId] = useState(0);

  const columns = useRef([
    { path: "ccoNo", label: "No." },
    { path: "supplementNo", label: "Supp." },
    { path: "description", label: "Description" },
    {
      path: "paymentMethods",
      label: "Pmt. Methods",
      content: (c) => renderPaymentMethods(c.paymentMethods),
    },
  ]);

  useEffect(() => {
    if (selectedCcoId) dispatch(ccoActions.getDetails(selectedCcoId, projectId));
  }, [selectedCcoId]);

  const handleClick_editCco = (e) => {
    e.preventDefault();
    setModalState_edit({ showModal: true, ccoId: selectedCcoId });
  };

  const handleClick_addCco = (e) => {
    e.preventDefault();
    setModalState_edit({ showModal: true, ccoId: null });
  };

  const data = useMemo(() => {
    const filteredByDesc =
      descFilter !== null
        ? (projCcoList || []).filter((c) =>
            c.description.toLowerCase().includes(descFilter.trim().toLowerCase())
          )
        : projCcoList || [];
    return _.orderBy(filteredByDesc, [sortColumn.path], [sortColumn.order]);
  }, [projCcoList, descFilter, sortColumn]);

  const renderPaymentMethods = (pmtMethods) => {
    if (!pmtMethods) return;
    const ccosSplit = pmtMethods.split(",");
    return ccosSplit.length > 0 ? (
      ccosSplit.map((c) => (
        <span key={`pmtMethodKey_${c}`} className="span-bubble p-1 bg-info mr-1">
          {c}
        </span>
      ))
    ) : (
      <span key={`pmtMethodKey_none`} className="span-bubble p-1 bg-info">
        (none)
      </span>
    );
  };

  const renderTableFilters = () => {
    return (
      <div className="d-flex flex-row flex-wrap pa-filter-group w-100 mb-1">
        <div className="pa-filter-item pa-filter-item__input flex-grow-1">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="descFilter"
              id="descFilter"
              className="form-control mr-2"
              value={descFilter}
              onChange={(e) => setDescFilter(e.target.value)}
              placeholder="No/Desc"
            />
          </div>
        </div>
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="addCco"
            id="addCco"
            className="btn btn-info"
            onClick={handleClick_addCco}
            disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
          >
            <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
            Add...
          </button>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="d-flex flex-row p-2 w-100">
        <div className="pa-list">
          {renderTableFilters()}
          <div className="pa-list__table--wrapper border">
            <Table
              className="table table-sm table-hover pa-list__table"
              data={data}
              columns={columns.current}
              idPropName="ccoId"
              selectedItemId={selectedCcoId}
              sortColumn={sortColumn}
              onSort={setSortColumn}
              handleClick_tr={(cco) => setSelectedCcoId(cco.ccoId)}
            />
          </div>
        </div>
        <div className="pa-details">
          <div className="card">
            <div className="card-header bg-lightgray">CCO Details</div>
            <div className="card-body p-3">
              <ProjAdminCcoDetails
                permissions={permissions}
                projectId={projectId}
                ccoId={selectedCcoId}
                handleClick_editCco={handleClick_editCco}
                deleteCallback={() => setSelectedCcoId(0)}
              />
            </div>
          </div>
        </div>
        {modalState_edit.showModal && (
          <EditCcoModalV2
            projectId={projectId}
            ccoId={modalState_edit.ccoId}
            showModal={modalState_edit.showModal}
            toggleModal={toggleModal_edit}
          />
        )}
      </div>
    </React.Fragment>
  );
}
